<template>
  <div class="login_wrap" :style="theme === 'renshe' ? { minHeight: '820px' } : { minHeight: '820px' }">
		<div>
			<!-- 人社、且行业标签不是交通 -->
			<img v-if="theme === 'renshe' && branchIndustry !== 'traffic'" src="@/assets/images/rs_logo.png" alt="" class="logo" />
			<img v-else-if="theme !== 'honghui' && loginBackgroundLogo" :src="loginBackgroundLogo" alt="" class="login-top" />
		</div>
    <div class="login register">
      <div class="bg_width"></div>
      <img :src="loginImg" alt="" class="login-left" />
      <div class="login-box">
        <ul class="tabs">
              <li class="tab-item">{{$t('MAIN_WEB_RESET_PASSWORD',{text:'重置密码'})}}</li>
          </ul>
        <el-form ref="form" :model="forget" :rules="rules">
          <el-form-item  prop="account" class="mt32">
            <el-input
              :placeholder="$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER',{text:'请输入手机号'})"
              v-model="forget.account"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item  prop="authCode" class="mt32 input_auth_btn">
            <el-input
              :placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE',{text:'请输入验证码'})"
              v-model="forget.authCode"
              key="authCode">
            </el-input>
            <div  class="count_down"
										@click="postAccountGetAuthCode"
										:class="{active_btn: 0 < Countdown.time}">
									{{ 0 >= Countdown.time ? $t('MAIN_WEB_OBTAIN_VERIFICATION_CODE',{text:'获取验证码'}) : countTimer }}
            </div>
          </el-form-item>
          <input type="text"  style="position:absolute;display:block;width:0;height:0;border-width:0"/>
          <el-form-item  prop="password" class="mt32">
            <el-input
              :placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD',{text:'请输入新密码'})"
              v-model="forget.password"
              auto-complete="new-password">
            </el-input>
          </el-form-item>
          <el-form-item class="mt32">
            <el-button type="primary" class="login-btn" @click="onSubmit">{{$t('MAIN_WEB_OK',{text:'确定'})}}</el-button>
          </el-form-item>
          <div class="bottom mt16">
            <span class="tip">
              {{$t('MAIN_WEB_EXISTING_ACCOUNT',{text:'已有账号？'})}}
              <router-link :to="{ name: 'login', query: { account: this.forget.account } }">{{$t('MAIN_WEB_LOG_ON_NOW',{text:'马上登录'})}}</router-link>
            </span>
            <div class="clear"></div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { phoneNumberValidator, passwordValidator, isPhone } from '@/util/validate';
export default {
  name: 'forget',
  data () {
    return {
			Countdown: {
				time: 0,
			},
      forget: {
        account: '',
        password: '',
        authCode: ''
      },
			loginImg: '',
      defaultLogo: require('../../assets/images/logo@2x.png'),
			defaultImg: require('../../assets/images/pexels.png'),
      loginBackgroundLogo: '',
      branchIndustry:'',
    };
  },
	computed: {
    ...mapState(['theme']),
		countTimer() {
			return  this.Countdown.time + 's'+this.$t('MAIN_WEB_THEN_RETRIEVE',{text:'后重新获取'})
    },
    rules(){
      return{
        account: [
          {
            required: true,
            message: this.$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER',{text:'请输入手机号'}),
            trigger: 'blur',
          },
          {
            validator: phoneNumberValidator,
            trigger: 'blur',
            message: this.$t('MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER',{text:'请输入正确的手机号'}),
          }
        ],
        password: [
          { required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD',{text:'请输入新密码'}), trigger: 'blur' },
          { validator: passwordValidator, trigger: 'blur' }
        ],
        authCode: [
          { required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE',{text:'请输入验证码'}), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE',{text:'请输入六位验证码'}), trigger: 'blur' }
        ]
      }
    }
	},
  created () {
    this.getNewConfiguration();
    this.forget.account = this.$route.query.account || ''
    this.loginImg = localStorage.getItem('loginImg') || this.defaultImg;
		var configurationConfig = JSON.parse(localStorage.getItem("configurationConfig"));
		configurationConfig && configurationConfig.map((item) => {
			if (item.key === 'login_background_logo') {
        this.loginBackgroundLogo = item.value || this.defaultLogo
			}
		})
  },
  methods: {
     getNewConfiguration() {
        let branchIndustry = localStorage.getItem('branchIndustry')||sessionStorage.getItem('branchIndustry')
        this.branchIndustry =  branchIndustry
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.resetPasswordNew()
        } else {
          return false;
        }
      })
    },
    resetPasswordNew () {
      const data = {
        ...this.forget
      }
      this.$api.operate.postAccountResetPasswordNew( data ).then(res => {
        res.data && this.$router.push({ name: 'login', query: { account: this.forget.account } })
      })
    },
    postAccountGetAuthCode () {
      const data = {
        phone: this.forget.account,
        adminFlag: 1
      }
      if ( !isPhone.test(data.phone) ) return
      if (this.Countdown.time > 0) return
      this.Countdown.time = 60
      this.$api.operate.postAccountGetAuthCode({ data }).then(() => {
        this.setCountdown()
      })
    },
    setCountdown () {
      let Countdown = null

      Countdown = setInterval(() => {
        this.Countdown.time--
        if (Countdown <= 0) {
          clearInterval(Countdown)
        }
      }, 1000)
    }
  }
};
</script>

<style lang="stylus" scoped>
@import 'index.styl'
.register
  .tabs .tab-item
    margin-bottom 0
    color #000
  .bottom
    .tip
      color #666666
      a
        &:hover
          text-decoration:underline
/deep/ .el-form-item__error
  left 0
  padding-top 8px
/deep/ .el-input__inner
  -webkit-box-shadow 0 0 0 1000px #ffffff inset


html[data-theme="red"] {
  .register .bottom .tip a {
    color #EB5461!important
  }
  .bg_width {
    background-color #EB5461!important
  }
  .count_down {
    color #EB5461!important
  }
}

html[data-theme="init"] {
  .register .bottom .tip a {
    color #1972FF!important
  }
  .bg_width {
    background-color #1972FF!important
  }
  .count_down {
    color #1972FF!important
  }
}
</style>
